
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const SubmissionWarningDialog = ({ 
  open, 
  onConfirm, 
  onCancel, 
  unansweredQuestions 
}) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Incomplete Answers Detected</AlertDialogTitle>
          <AlertDialogDescription>
            You have not answered the following questions:
            <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded-md max-h-60 overflow-y-auto">
              <ul className="list-disc list-inside text-sm space-y-1">
                {unansweredQuestions.map((questionNum) => (
                  <li key={questionNum} className="py-0.5">Question {questionNum}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 text-sm font-medium text-gray-700">
              Are you sure you want to submit the exam without answering these questions?
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Cancel & Continue
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700"
          >
            Yes, Submit Anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SubmissionWarningDialog;